import React from 'react';

const FieldError = React.createClass({
    propTypes: {
        errors: React.PropTypes.array,
    },

    getDefaultProps() {
        return {
            errors: [],
        };
    },

    render() {
        let errorList = this.props.errors;
        return (
            <div>
                {typeof this.props.errors[0] !== 'undefined' ? (
                    <div className="error-container error-right">
                        <div className="error">
                            <div className="arrow" />
                            <div className="error-content">
                                <ul className="list-unstyled">
                                    {errorList.map(function(text, index) {
                                        return (
                                            <li key={index}>{text}</li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
});

export default FieldError;


/** WEBPACK FOOTER **
 ** ./src/components/Fragments/FieldError.js
 **/